import { render } from "./TDSettingsPage.vue?vue&type=template&id=0a759400"
import script from "./TDSettingsPage.vue?vue&type=script&lang=js"
export * from "./TDSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__